import { GaugeColorSegment, GaugeSegments } from 'app/shared/elements/gauges/gauge-segments';

/**
 * Determine a discrete color in an array based on an input value.
 * A value below the first threshold value is mapped to the first item.  Values above the last threshold value are mapped to the last item.
 * @param {number} value An input number
 * @param {GaugeSegments} segments The scheme from which the color will be chosen.
 * @param {number} [maxVal=100] The max range of input values.  Used to determine equal distribution of string segments.
 * @param {number} [minVal=0] The min range of input values,  Used to determine equal distribution of string segments.
 */
export function asColor(value: number, segments: string[], maxVal: number, minVal: number): string;
export function asColor(value: number, segments: GaugeColorSegment[]): string;
export function asColor(value: number, segments: GaugeSegments, maxVal: number = 100, minVal: number = 0): string {
    //Convert array of strings to array of equal sized Segments
    segments = (segments as (GaugeColorSegment | string)[]).map<GaugeColorSegment>((option, index) => {
        if(typeof option === 'string') {
            option = { threshold: (maxVal - minVal) * ((index + 1) / segments.length) + minVal, color: option };
        }
        return option;
    });

    // Ensure the array is sorted
    segments = segments.sort((a, b) => a.threshold - b.threshold);

    // Get the element for the largest threshold value less than the input, or the last element if value belongs at the end of array or if array is empty
    const { color } = segments.find((s) => value <= s.threshold) || segments[segments.length - 1];
    return color;
}
